import axios from 'axios'
import * as qiniu from 'qiniu-js'
export const ResHandle = res => {
  return {
    status: res.status,
    error_code: res.data.error_code || ''
  }
}

/** 文件下载
 * content  返回结果   字符串
 * fileName 文件名
 */
export const funDownload = (content, filename) => {
  const eleLink = document.createElement('a')
  eleLink.download = filename
  eleLink.style.display = 'none'
  // 字符内容转变成blob地址
  const blob = new Blob([content])
  eleLink.href = URL.createObjectURL(blob)
  // 触发点击
  document.body.appendChild(eleLink)
  eleLink.click()
  // 然后移除
  document.body.removeChild(eleLink)
}

export const openLink = (url, newpage) => {
  newpage.location.href = url
}

// 删除对象空属性
export const deleteEmptyObj = obj => {
  Object.keys(obj).forEach(key => {
    if (!obj[key]) {
      delete obj[key]
    }
  })
}

// 判断是否邮箱
export const isMail = str => {
  return /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(str)
}
// 判断操作系统
export const detectOS = () => {
  const sUserAgent = navigator.userAgent
  const isWin =
    navigator.platform === 'Win32' || navigator.platform === 'Windows'
  const isMac =
    navigator.platform === 'Mac68K' ||
    navigator.platform === 'MacPPC' ||
    navigator.platform === 'Macintosh' ||
    navigator.platform === 'MacIntel'
  if (isMac) return 'Mac'
  const isUnix = navigator.platform === 'X11' && !isWin && !isMac
  if (isUnix) return 'Unix'
  const isLinux = String(navigator.platform).indexOf('Linux') > -1
  if (isLinux) return 'Linux'
  if (isWin) {
    const isWin2K =
      sUserAgent.indexOf('Windows NT 5.0') > -1 ||
      sUserAgent.indexOf('Windows 2000') > -1
    if (isWin2K) return 'Win2000'
    const isWinXP =
      sUserAgent.indexOf('Windows NT 5.1') > -1 ||
      sUserAgent.indexOf('Windows XP') > -1
    if (isWinXP) return 'WinXP'
    const isWin2003 =
      sUserAgent.indexOf('Windows NT 5.2') > -1 ||
      sUserAgent.indexOf('Windows 2003') > -1
    if (isWin2003) return 'Win2003'
    const isWinVista =
      sUserAgent.indexOf('Windows NT 6.0') > -1 ||
      sUserAgent.indexOf('Windows Vista') > -1
    if (isWinVista) return 'WinVista'
    const isWin7 =
      sUserAgent.indexOf('Windows NT 6.1') > -1 ||
      sUserAgent.indexOf('Windows 7') > -1
    if (isWin7) return 'Win7'
    const isWin10 =
      sUserAgent.indexOf('Windows NT 10.0') > -1 ||
      sUserAgent.indexOf('Windows 10') > -1
    if (isWin10) return 'Win10'
  }
  return 'other'
}
// 中间页跳转URL格式化
export const urlFormat = url => {
  const linkInfo = url.split('?')[1].split('&')
  const data = {
    code: linkInfo[0].split('=')[1],
    pid: linkInfo[1].split('=')[1]
  }
  return data
}
export const cutString = (str, len) => {
  // length属性读出来的汉字长度为1
  if (!str) return
  if (str.length * 2 <= len) {
    return str
  }

  let strlen = 0

  let s = ''

  for (let i = 0; i < str.length; i++) {
    s = s + str.charAt(i)

    if (str.charCodeAt(i) > 128) {
      strlen = strlen + 2

      if (strlen >= len) {
        return s.substring(0, s.length - 1) + '...'
      }
    } else {
      strlen = strlen + 1

      if (strlen >= len) {
        return s.substring(0, s.length - 2) + '...'
      }
    }
  }

  return s
}

/**
 *
 * @param {*} file 文件实例
 */
export const qiniuUpload = async file => {
  const sufix = getFileSufix(file.name)
  const token_url = `${CONFIG.api_edu}/edu/qiniu/token`
  const params = {
    type: sufix || '',
    bucket_type: 1
  }
  if (!params.type) {
    delete params.type
  }
  const response = await API.get(token_url, params)
  const host = response.data.bucket_url
  const putExtra = {
    fname: '',
    params: {},
    mimeType: [] || null
  }
  const config = {
    useCdnDomain: true, // 表示是否使用 cdn 加速域名，为布尔值，true 表示使用，默认为 false。
    region: qiniu.region.na0, // 根据具体提示修改上传地区,当为 null 或 undefined 时，自动分析上传域名区域
    uphost: 'up-na0.qiniup.com'
  }

  const fileName = `upload/${Date.parse(new Date())}/${file.name}`
  const observable = qiniu.upload(
    file,
    fileName,
    response.data.token,
    putExtra,
    config
  )

  return new Promise((resolve, reject) => {
    observable.subscribe({
      next: res => {
        // 主要用来展示进度
      },
      error: err => {
        console.error(err)
        // 失败报错信息
      },
      complete: res => {
        // 接收成功后返回的信息
        const fileName = host + '/' + res.key
        resolve(fileName)
      }
    })
  })
}

export const encryptionQiNiuUpload = async (file, cb, errorCb) => {
  axios.defaults.headers.common['Authorization'] =
    'Bearer ' + localStorage.getItem('token')
  const data = new FormData()
  data.append('file', file)
  const res = await axios({
    url: `${CONFIG.api_edu}/edu/base/qiniu/upload?prefix=zone`,
    method: 'post',
    onUploadProgress(progressEvent) {
      if (progressEvent.lengthComputable && cb) {
        cb(progressEvent)
      }
    },
    data: data,
    timeout: 0,
    withCredentials: false
  }).catch(e => {
    if (errorCb) {
      errorCb()
    }
  })
  if (res.status < 400) {
    const result = {
      status: res.status,
      fileUrl: res.data.resource_url
    }
    return result
  } else {
    return { status: 400 }
  }
}

// 获取文件后缀
export const getFileSufix = filename => {
  const arr = filename.split('.')
  const name = arr[arr.length - 1].split('?')
  return name[0]
}

/**
 * url 下载ulr
 * filename 文件名
 * downloadCb 下载进度条回调
 * errorCb 失败回调
 */
export const downloadFromQiniu = async (url, fileName, downloadCb, errorCb) => {
  const res = await axios({
    method: 'get',
    url: url,
    headers: {},
    responseType: 'arraybuffer',
    withCredentials: false,
    timeout: 0,
    onDownloadProgress(progressEvent) {
      if (downloadCb && progressEvent.lengthComputable) {
        downloadCb(progressEvent)
      }
    }
  }).catch(e => {
    if (errorCb) {
      errorCb()
    }
  })
  if (res.status === 200) {
    const sufix = getFileSufix(url)
    funDownload(res.data, fileName + '.' + sufix)
  }
}

export const workScoreFilter = value => {
  if (value >= 0 && value < 10) {
    return 0
  } else if (value >= 10 && value < 20) {
    return 0.5
  } else if (value >= 20 && value < 30) {
    return 1
  } else if (value >= 30 && value < 40) {
    return 1.5
  } else if (value >= 40 && value < 50) {
    return 2
  } else if (value >= 50 && value < 60) {
    return 2.5
  } else if (value >= 60 && value < 70) {
    return 3
  } else if (value >= 70 && value < 80) {
    return 3.5
  } else if (value >= 80 && value < 90) {
    return 4
  } else if (value >= 90 && value < 100) {
    return 4.5
  } else if (value === 100) {
    return 5
  }
}

export const formatMenu = (value, spliceValue) => {
  const index = value.indexOf(spliceValue)
  if (index > -1) {
    value.splice(index, 1)
  }
  return value
}

// 格式化时间, 接收秒时间戳/毫秒时间戳/时间实例
export function formatDate(timestamp, format = 'Y-m-d H:m:s') {
  if (timestamp === null || timestamp === 0) return ''
  const jsdate =
    timestamp === undefined
      ? new Date() // Not provided
      : timestamp instanceof Date
        ? new Date(timestamp) // JS Date()
        : new Date(
          (timestamp >= 10000000000
            ? Math.round(timestamp / 1000)
            : timestamp) * 1000
        )

  const txt_words = [
    'Sun',
    'Mon',
    'Tues',
    'Wednes',
    'Thurs',
    'Fri',
    'Satur',
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
  ]
  // trailing backslash -> (dropped)
  // a backslash followed by any character (including backslash) -> the character
  // empty string -> empty string
  const formatChr = /\\?(.?)/gi
  const formatChrCb = function(t, s) {
    return f[t] ? f[t]() : s
  }
  const _pad = function(n, c) {
    n = String(n)
    while (n.length < c) {
      n = '0' + n
    }
    return n
  }
  const f = {
    // Day
    d: function() {
      // Day of month w/leading 0; 01..31
      return _pad(f.j(), 2)
    },
    D: function() {
      // Shorthand day name; Mon...Sun
      return f.l().slice(0, 3)
    },
    j: function() {
      // Day of month; 1..31
      return jsdate.getDate()
    },
    l: function() {
      // Full day name; Monday...Sunday
      return txt_words[f.w()] + 'day'
    },
    N: function() {
      // ISO-8601 day of week; 1[Mon]..7[Sun]
      return f.w() || 7
    },
    S: function() {
      // Ordinal suffix for day of month; st, nd, rd, th
      const j = f.j()
      let i = j % 10
      if (i <= 3 && parseInt((j % 100) / 10, 10) === 1) {
        i = 0
      }
      return ['st', 'nd', 'rd'][i - 1] || 'th'
    },
    w: function() {
      // Day of week; 0[Sun]..6[Sat]
      return jsdate.getDay()
    },
    z: function() {
      // Day of year; 0..365
      const a = new Date(f.Y(), f.n() - 1, f.j())
      const b = new Date(f.Y(), 0, 1)
      return Math.round((a - b) / 864e5)
    },

    // Week
    W: function() {
      // ISO-8601 week number
      const a = new Date(f.Y(), f.n() - 1, f.j() - f.N() + 3)
      const b = new Date(a.getFullYear(), 0, 4)
      return _pad(1 + Math.round((a - b) / 864e5 / 7), 2)
    },

    // Month
    F: function() {
      // Full month name; January...December
      return txt_words[6 + f.n()]
    },
    m: function() {
      // Month w/leading 0; 01...12
      return _pad(f.n(), 2)
    },
    M: function() {
      // Shorthand month name; Jan...Dec
      return f.F().slice(0, 3)
    },
    n: function() {
      // Month; 1...12
      return jsdate.getMonth() + 1
    },
    t: function() {
      // Days in month; 28...31
      return new Date(f.Y(), f.n(), 0).getDate()
    },

    // Year
    L: function() {
      // Is leap year?; 0 or 1
      const j = f.Y()
      return ((j % 4 === 0) & (j % 100 !== 0)) | (j % 400 === 0)
    },
    o: function() {
      // ISO-8601 year
      const n = f.n()
      const W = f.W()
      const Y = f.Y()
      return Y + (n === 12 && W < 9 ? 1 : n === 1 && W > 9 ? -1 : 0)
    },
    Y: function() {
      // Full year; e.g. 1980...2010
      return jsdate.getFullYear()
    },
    y: function() {
      // Last two digits of year; 00...99
      return f
        .Y()
        .toString()
        .slice(-2)
    },

    // Time
    a: function() {
      // am or pm
      return jsdate.getHours() > 11 ? 'pm' : 'am'
    },
    A: function() {
      // AM or PM
      return f.a().toUpperCase()
    },
    B: function() {
      // Swatch Internet time; 000..999
      const H = jsdate.getUTCHours() * 36e2
      // Hours
      const i = jsdate.getUTCMinutes() * 60
      // Minutes
      const s = jsdate.getUTCSeconds() // Seconds
      return _pad(Math.floor((H + i + s + 36e2) / 86.4) % 1e3, 3)
    },
    g: function() {
      // 12-Hours; 1..12
      return f.G() % 12 || 12
    },
    G: function() {
      // 24-Hours; 0..23
      return jsdate.getHours()
    },
    h: function() {
      // 12-Hours w/leading 0; 01..12
      return _pad(f.g(), 2)
    },
    H: function() {
      // 24-Hours w/leading 0; 00..23
      return _pad(f.G(), 2)
    },
    i: function() {
      // Minutes w/leading 0; 00..59
      return _pad(jsdate.getMinutes(), 2)
    },
    s: function() {
      // Seconds w/leading 0; 00..59
      return _pad(jsdate.getSeconds(), 2)
    },
    u: function() {
      // Microseconds; 000000-999000
      return _pad(jsdate.getMilliseconds() * 1000, 6)
    },

    // Timezone
    e: function() {
      // Timezone identifier; e.g. Atlantic/Azores, ...
      // The following works, but requires inclusion of the very large
      // timezone_abbreviations_list() function.
      /*              return that.date_default_timezone_get();
               */
      console.error(
        'Not supported (see source code of date() for timezone on how to add support'
      )
    },
    I: function() {
      // DST observed?; 0 or 1
      // Compares Jan 1 minus Jan 1 UTC to Jul 1 minus Jul 1 UTC.
      // If they are not equal, then DST is observed.
      const a = new Date(f.Y(), 0)
      // Jan 1
      const c = Date.UTC(f.Y(), 0)
      // Jan 1 UTC
      const b = new Date(f.Y(), 6)
      // Jul 1
      const d = Date.UTC(f.Y(), 6) // Jul 1 UTC
      return a - c !== b - d ? 1 : 0
    },
    O: function() {
      // Difference to GMT in hour format; e.g. +0200
      const tzo = jsdate.getTimezoneOffset()
      const a = Math.abs(tzo)
      return (
        (tzo > 0 ? '-' : '+') + _pad(Math.floor(a / 60) * 100 + (a % 60), 4)
      )
    },
    P: function() {
      // Difference to GMT w/colon; e.g. +02:00
      const O = f.O()
      return O.substr(0, 3) + ':' + O.substr(3, 2)
    },
    T: function() {
      return 'UTC'
    },
    Z: function() {
      // Timezone offset in seconds (-43200...50400)
      return -jsdate.getTimezoneOffset() * 60
    },

    // Full Date/Time
    c: function() {
      // ISO-8601 date.
      return 'Y-m-d\\TH:i:sP'.replace(formatChr, formatChrCb)
    },
    r: function() {
      // RFC 2822
      return 'D, d M Y H:i:s O'.replace(formatChr, formatChrCb)
    },
    U: function() {
      // Seconds since UNIX epoch
      return (jsdate / 1000) | 0
    }
  }

  return format.replace(formatChr, formatChrCb)
}
